import { MutableRefObject } from 'react';

export function stashPreviousElement(
  previousActiveElementRef: MutableRefObject<HTMLElement | null>,
) {
  const activeElement = document.activeElement;
  previousActiveElementRef.current = activeElement instanceof HTMLElement ? activeElement : null;
}

export function restorePreviousElement(
  previousActiveElementRef: MutableRefObject<HTMLElement | null>,
) {
  const previousActiveElement = previousActiveElementRef.current;
  previousActiveElementRef.current = null;

  if (!previousActiveElement?.isConnected) {
    return;
  }

  requestAnimationFrame(() => previousActiveElement.focus());
}
